import { ROLE } from 'services/assist-api/entities/role/roles';

/**
 * Query params for fetching marks (with items and marker details) for a particular response.
 */
export function marksOfResponseParams(responseId: number): RequestParams {
  return {
    filters: { testInstanceResponse: responseId },
    groups: [
      'id',
      'testinstanceresponsemarkitem-inputtype',
      'testinstanceresponsemark-testinstanceresponse',
      'testinstanceresponsemark-activemarker',
      'testinstanceresponsemark-markers',
      'testinstanceresponsemarker-user',
      'testinstanceresponsemark-markitems',
      'testinstanceresponsemarkitem-testinstanceresponsemarker', // The active marker of the mark item
      'testinstanceresponsemarkitem-testrubricitem'
    ],
    include: 'markers,markItems'
  };
}

/**
 * Query params for fetching test instance response markers for a particular
 * test instance response.
 */
export function markersOfResponseParams(responseId: number): RequestParams {
  return {
    filters: { testInstanceResponse: responseId },
    groups: [
      'id',
      'testinstanceresponsemarker-testinstanceresponse',
      'testinstanceresponsemarker-user',
      'customersusers-user'
    ],
    include: 'activeResponseMarks,user'
  };
}

/**
 * Query params for fetching organisation users who have the marker role.
 */
export function organisationUsersWithMarkerRoleParams(
  organisationId?: number,
  organisationUserIds?: number[]
): RequestParams {
  return {
    filters: {
      id: organisationUserIds,
      'roles.name': ROLE.MARKER,
      customer: organisationId
    },
    groups: ['id']
  };
}

export const markReviewerRoles = [ROLE.MARKING_ADMIN];

/**
 * Query params for fetching organisation users who have a reviewer role (marking admin) but
 * excluding other users within the organisation.
 */
export function organisationUsersWithMarkReviewerRoleParams(
  organisationId?: number,
  organisationUserIds?: number[]
): RequestParams {
  return {
    filters: {
      id: organisationUserIds,
      'roles.name': markReviewerRoles,
      customer: organisationId
    },
    groups: ['id']
  };
}
